import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router preserves the browser scroll position across navigations.
// Reset to the top whenever the path changes so a new page always opens at
// the top instead of wherever the clicked link happened to sit.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
